import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-captured-payment',
  templateUrl: './captured-payment.component.html',
  styleUrls: ['./captured-payment.component.css']
})
export class CapturedPaymentComponent implements OnInit {

  innerHeight: number = window.innerHeight;

  error: any;
  order_id: any;
  recharge: any;
  credit:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<CapturedPaymentComponent>,
    private tools: ToolsService,
    public translate: TranslateService
  ) {
    this.error = data.error ? data.error : null;
    this.recharge = data.recharge ? data.recharge : null;
    this.credit = data.credit ? data.credit : null;
   

  }

  ngOnInit() {
    this.order_id = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
  }

  closeDial(): void {
    this.dialogRef.close();
  }



}

